<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// I18N
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            per_month: "/ mois",
            per_year: "/ an",
            added: "Ajouté",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const props = withDefaults(
    defineProps<{
        name: string
        displayName: string
        /** Prix mensuel (affiché par an + par mois quand showYearly). */
        price: number
        /** Afficher prix par an avec prix/mois en dessous (engagement). */
        showYearly?: boolean
        isSelected?: boolean
    }>(),
    { isSelected: false, showYearly: false }
)

const emit = defineEmits<{
    (
        e: "update:moduleSelected",
        payload: { name: string; selected: boolean }
    ): void
}>()

// ================================
// HANDLERS
// ================================
function onClick(): void {
    emit("update:moduleSelected", {
        name: props.name,
        selected: !props.isSelected,
    })
}
</script>

<template>
    <button
        type="button"
        class="flex h-[4rem] flex-wrap items-center justify-center gap-3 py-2 px-3 rounded-lg border w-full text-left transition-colors cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
        :class="[
            isSelected
                ? 'border-primary-300 bg-primary-100 ring-1 ring-primary-200'
                : 'border-primary-200 bg-primary-50/50 hover:border-primary-300 hover:bg-primary-100/80',
        ]"
        @click="onClick"
    >
        <span class="font-medium text-primary-900 min-w-0 flex-1">
            {{ displayName }}
        </span>
        <span class="text-primary-700 shrink-0 flex flex-col items-end gap-0">
            <span class="flex items-baseline gap-1">
                <span class="font-semibold"
                    >{{ showYearly ? price * 12 : price }} €</span
                >
                <span class="text-primary-500 text-sm">{{
                    showYearly ? t("per_year") : t("per_month")
                }}</span>
            </span>
            <span v-if="showYearly" class="text-primary-600 text-xs">
                {{ price }} € {{ t("per_month") }}
            </span>
        </span>
        <span
            v-if="isSelected"
            class="inline-flex items-center gap-1.5 shrink-0 text-xs font-medium text-green-700"
        >
            <BaseIcon icon="pi pi-check" class="shrink-0" />
            {{ t("added") }}
        </span>
    </button>
</template>
